import { FORECAST_CONTEXT_DIMENSIONS } from "../forecastContext";
import type { SummaryViewPayload } from "./summaryViewPayload";

function dimLabel(key: string): string {
  return (
    FORECAST_CONTEXT_DIMENSIONS.find((option) => option.value === key)?.label ??
    key
  );
}

/**
 * One line naming everything a view will change, for the picker row —
 * derived from the payload, so a row can't promise what the view no longer
 * does.
 */
export function describeSummaryView(payload: SummaryViewPayload): string {
  const parts: string[] = [];
  const columns = payload.columns;
  if (columns) {
    parts.push(columns.category ?? "All KPIs");
    const changed = Object.keys(columns.visibility ?? {}).length;
    if (changed) {
      parts.push(`${changed} ${changed === 1 ? "column" : "columns"} changed`);
    }
  }
  const shape = payload.dataShape;
  if (shape?.planBy) parts.push(shape.planBy);
  if (shape?.agg) parts.push(shape.agg);
  if (payload.dims) {
    parts.push(
      `${dimLabel(payload.dims.tableDim)} × ${dimLabel(payload.dims.rowDim)}`
    );
  }
  return parts.join(" · ");
}
